export default __webpack_public_path__ + "static/media/belly-photo-DE.c19bd75c.png";